import { useContext, useEffect, useMemo, useState } from 'react'
import { FormField, Select, SimpleDatePicker, WithFormFeedback } from 'ab-uitools-legacy'
import { LoanDetailsContext, OfferContext, ScheduleContext } from '../../context'
import { LOAN_DURATION_OPTIONS, OFFERS_MOCK_DATA } from '../../consts'
import { useGetAppOffer, useGetScedule } from '../../hooks'
import { LOAN_DURATION, PAYMENT_DAY } from './consts'
import { getAllMonthsLastdays } from './utils'

import './index.scss'
import { useGetApplicationInfo } from '../../hooks/useGetApplicationInfo'

const LoanDetails = ({ setValue }) => {
  const { getAppOffers } = useGetAppOffer()
  const { getApplicationInfo } = useGetApplicationInfo()

  const { loanDetails, initialised, setInitialised } = useContext(LoanDetailsContext)
  const { scheduleData } = useContext(ScheduleContext)
  const { totalAmount } = scheduleData[0]

  const { preferredRepaymentDate, duration } = loanDetails

  const initialTerm =
    LOAN_DURATION_OPTIONS.find(
      (loanDuration) => duration && loanDuration.value === duration.toString()
    ) || LOAN_DURATION_OPTIONS[0]

  const [currentData, setData] = useState<{ date?: Date; term?: number | string }>({
    date: preferredRepaymentDate,
    term: initialTerm.value
  })

  const { setSceduleData } = useGetScedule()

  const getPerMonthFee = (terms) => {
    const { date, term } = terms
    setSceduleData({
      preferredRepaymentDay: date.getDate(),
      preferredRepaymentMonth: date.getMonth() + 1,
      preferredRepaymentDate: date,
      duration: term
    })
  }

  const onTermSelect = (selectedTerm) => {
    const { date } = currentData
    if (date) {
      getPerMonthFee({ term: selectedTerm, date })
    }
    setData({ ...currentData, term: selectedTerm })
  }

  const onDurationSelect = (date) => {
    const { term } = currentData
    if (term) {
      getPerMonthFee({ term, date })
    }

    setData({ ...currentData, date })
  }

  const { offers } = useContext(OfferContext)

  const offer = offers ? offers[0] || OFFERS_MOCK_DATA : OFFERS_MOCK_DATA // TODO maybe we need to remove this mock data

  const { minDuration, maxDuration } = offer

  const checkedDurationData = useMemo(() => {
    return LOAN_DURATION_OPTIONS.filter((duration) => {
      const selectedDuration = parseInt(duration.value)
      return selectedDuration >= minDuration && selectedDuration <= maxDuration
    })
  }, [minDuration, maxDuration])

  useEffect(() => {
    if (offers.length === 0) {
      getAppOffers()
    }
  }, [])

  useEffect(() => {
    if (!initialised) {
      getApplicationInfo()
      setInitialised(true)
    }
  }, [])

  useEffect(() => {
    if (loanDetails.duration) {
      setValue(LOAN_DURATION, loanDetails.duration?.toString())
    }
    if (loanDetails.preferredRepaymentDate) {
      setValue(PAYMENT_DAY, loanDetails.preferredRepaymentDate)
    }
  }, [loanDetails?.duration, loanDetails?.preferredRepaymentDate]);

  useEffect(() => {
    if (loanDetails.duration) {
      setData((prev) => ({ ...prev, term: loanDetails.duration.toString() }))
    }
  }, [loanDetails.duration])

  useEffect(() => {
    if (loanDetails.preferredRepaymentDate) {
      setData((prev) => ({ ...prev, date: loanDetails.preferredRepaymentDate }))
    }
  }, [loanDetails.preferredRepaymentDate])

  return (
    <div className="loan_details_container mt-24">
      <div className="loan_details_row">
        <FormField
          className="mb-24 loan_details_field"
          name={PAYMENT_DAY}
          isControlled
          isNeedChangeHandler
          As={(props) => {
            return <SimpleDatePicker
              key={preferredRepaymentDate ? 'loaded' : 'empty'}
              currentDate={preferredRepaymentDate}
              label="Ամենամսյա վճարման օր*"
              format="DD"
              excludeDates={getAllMonthsLastdays()}
              minDate={new Date(new Date().setDate(new Date().getDate() + 15))}
              maxDate={new Date(new Date().setDate(new Date().getDate() + 45))}
              changeHandler={onDurationSelect}
              {...props}
            />
          }}
        />
        <FormField
          className="mb-24 loan_details_field loan_duration_field"
          name={LOAN_DURATION}
          isControlled
          isNeedChangeHandler
          As={(props) => (
            <Select
              {...props}
              isRequiredField
              label="Վարկի ժամկետ"
              options={checkedDurationData}
              setSelectedItem={onTermSelect}
            />
          )}
        />
      </div>
    </div>
  )
}

export default LoanDetails
